import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { opsEstimateEndpoints } from '@/lib/api/endpoints';
import { estimateKeys } from '@/lib/queryKeys';

/**
 * Previews the next estimate number for pre-filling the create form.
 * Read-only — does not reserve the number. Disable in edit mode.
 */
export function useNextEstimateNumber(options?: { enabled?: boolean }) {
  return useApiQuery<{ estimateNumber: string }>({
    queryKey: estimateKeys.nextNumber(),
    queryFn: () => apiGet(operationsClient, opsEstimateEndpoints.nextNumber()),
    enabled: options?.enabled,
    showErrorToast: false, // graceful: if it fails, the field just stays empty
  });
}
